import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { AccountOpeningV2KYCFailureNotLockedOutStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2KYCFailureNotLockedOutStepTemplate = ({ resource }) => {
  return (
    <WorkflowLayout appearance="elevated" resource={resource}>
      <FDContentContainer maxWidth="sm">
        <MetaResourceRenderer
          metaOverrideSet={metaOverrideSet}
          layout={AccountOpeningV2KYCFailureNotLockedOutStepLayout}
          resource={resource}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2KYCFailureNotLockedOutStepTemplate.defaultProps = {
};

AccountOpeningV2KYCFailureNotLockedOutStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
